module.exports = __webpack_public_path__ + "img/4.b53f35de.png";